import { lenis } from "../lenis";

export function initMenuToggle() {
    const openBtn = document.querySelector(".mm-open");
    const closeBtns = document.querySelectorAll(".mm-close");
    const loginBtns = document.querySelectorAll(".login-open");
    const delay = 300;

    function closeModel() {
        document.body.classList.remove("model-active-menu", "model-active-login");
        removeLoginHash();
    }

    function addLoginHash() {
        if (window.location.hash !== "#login") {
            history.pushState(null, "", "#login");
        }
    }

    function removeLoginHash() {
        if (window.location.hash === "#login") {
            history.replaceState(null, "", window.location.pathname + window.location.search);
        }
    }

    if (openBtn) {
        openBtn.addEventListener("click", function (e) {
            e.preventDefault();
            closeModel();
            document.body.classList.add("model-active-menu");
            lenis.stop();
        });
    }

    if (closeBtns.length > 0) {
        closeBtns.forEach(function (closeBtn) {
            closeBtn.addEventListener("click", function () {
                closeModel();
                lenis.start();
            });
        })        
    }

    if (loginBtns.length > 0) {
        loginBtns.forEach(function (loginBtn) {
            loginBtn.addEventListener("click", function () {
                const hasMenuActive =
                    document.body.classList.contains("model-active-menu");
                closeModel();
                if (hasMenuActive) {
                    setTimeout(() => {
                        document.body.classList.add("model-active-login");
                        addLoginHash();
                    }, delay);
                } else {
                    document.body.classList.add("model-active-login");
                    addLoginHash();
                }
                lenis.stop();
            });
        });
    }

    // Auto open login modal if hash is #login
    if (window.location.hash === "#login") {
        document.body.classList.add("model-active-login");
        lenis.stop();
    }

    // lenis bug workarund for models.
    document.addEventListener('wheel', (e) => {
    if (e.target.closest('.modal-scroll')) {
        e.stopPropagation(); // prevent Lenis interception
    }
    }, { passive: false });

    document.addEventListener('touchmove', (e) => {
    if (e.target.closest('.modal-scroll')) {
        e.stopPropagation();
    }
    }, { passive: false });

}

export function closeModel() {
    document.body.classList.forEach((className) => {
        if (className.startsWith("model-active")) {
            document.body.classList.remove(className);
        }
    });
}
